module.exports = __webpack_public_path__ + "img/video.f8440f15.svg";